export type Language = "en" | "my";

const messages = {
  en: {
    appName: "My-Hub",
    pos: "3DPOS",
    dashboard: "Dashboard",
    entries: "Number entry",
    vouchers: "Vouchers",
    reports: "Summary reports",
    results: "Winning number",
    employees: "Employees",
    settings: "Settings",
    signOut: "Sign out",
    signIn: "Sign in",
    username: "Username",
    password: "Password",
    fullName: "Full name",
    customerName: "Customer name",
    amount: "Amount",
    totalAmount: "Total Amount",
    maxLimit: "Shared max amount per number",
    save: "Save",
    cancel: "Cancel",
    copy: "Copy list",
    copyOverage: "Copy excess only",
    copyOverageStateFailed: "Unable to load previously copied amounts. Copy is disabled to avoid sending the same excess twice.",
    noNewOverageToCopy: "No new excess to copy since the last successful copy.",
    copyOverageSuccess: "Copied only the new excess and saved it as sent for this draw. Future copies will exclude it.",
    copyOverageClipboardFailed: "Clipboard copy failed. No amount was marked as sent.",
    copyOverageTrackingFailed: "Copied, but its sent status could not be saved. A later copy might include it again; refresh and check.",
    copied: "Copied",
    addNumber: "Add number",
    addLine: "Add line",
    singleEntry: "Single / multiple rows",
    bulkEntry: "Paste many rows",
    bulkHint: "One per line: 123 5000; 259 R 25000 (same on all 6); 259 30000 R 20000 (259 gets 30000, other 5 get 20000); next bare number inherits the rule; T 25000 for all ten triples.",
    betNotationHint: "R/r applies to unique permutations. With two amounts, the original number gets the first amount and the other permutations get the amount after R/r. A bare number inherits the last rule. T adds 000, 111, …, 999 at the stated amount each.",
    choosePhoto: "Choose from gallery/files",
    takePhoto: "Take a photo",
    readPhoto: "Read with Cloudflare AI",
    clearPhoto: "Clear photo and OCR results",
    ocrCloudflareHint: "The compressed photo is sent to Cloudflare Workers AI (Qwen 3.8 Vision). It may still misread handwriting; compare every number and amount with the original photo. Usage depends on image/output tokens. Workers AI includes 10,000 Neurons/day; requests over quota fail on Workers Free and may be billed on Workers Paid.",
    ocrReading: "Cloudflare AI is reading",
    ocrReady: "AI suggestions are in the bulk-entry box. Review and correct each line against the original photo.",
    ocrUnrecognized: "Unrecognized text — review before saving",
    ocrRawText: "Raw AI response",
    ocrNoEntries: "AI could not identify any wager rows. The photo is still available for review. Try a close, sharp, well-lit photo of the page, or enter the rows manually.",
    ocrHumanConfirm: "I checked every imported number and amount against the photo and reviewed unrecognized text. I will only save the corrected list.",
    ocrImageOnly: "Please select an image file.",
    ocrImageTooLarge: "Image file must be 12 MB or smaller.",
    ocrReplacePrompt: "Reading this photo will replace current entry lines. Continue?",
    ocrFailed: "Cloudflare AI could not read the photo. Try a clearer image or enter the rows manually.",
    selectedPhoto: "Selected source photo for OCR review",
    deletePermanent: "Delete permanently",
    deleteVoucherTitle: "Permanently delete voucher",
    deleteVoucherSummary: "Voucher ID",
    deleteVoucherWarning: "This permanently deletes the voucher and its number lines, removes it from totals/reports, and cannot be undone. Use Void instead if you need to retain the record.",
    deleteVoucherAcknowledge: "I understand this deletion cannot be undone.",
    deleteVoucherConfirm: "Delete forever",
    deleteVoucherSuccess: "Voucher permanently deleted.",
    deleteVoucherError: "Unable to permanently delete voucher.",
    number: "Number",
    overLimit: "Over limit",
    noLimit: "Set a shared max amount in Settings to enable limit checks.",
    totalSales: "Total sales",
    voucherCount: "Vouchers",
    currentDraw: "Current draw",
    newDraw: "Start new draw",
    closeDraw: "This closes the current draw and starts a new one.",
    drawName: "Draw name",
    drawDate: "Draw date",
    winningNumber: "Winning number (000–999)",
    saveResult: "Save result",
    manualResult: "Enter result manually",
    syncApi: "Sync API",
    apiPending: "Set SETLIVE_API_KEY in Cloudflare to sync the latest GLO-backed 3D result. Check its date and number against the official source.",
    search: "Search name or voucher ID",
    from: "From",
    to: "To",
    downloadCsv: "Download CSV",
    employee: "Employee",
    createEmployee: "Create employee",
    active: "Active",
    inactive: "Inactive",
    deactivate: "Deactivate",
    activate: "Activate",
    print: "Print voucher",
    void: "Void voucher",
    edit: "Edit",
    reason: "Reason",
    overrideReason: "Admin override reason",
    loginIntro: "Sign in to your number ledger.",
    setupIntro: "Create the first Admin account to secure this workspace.",
    bootstrapKey: "Setup key",
    setupAdmin: "Create Admin",
    noEntries: "No entries yet.",
    noVouchers: "No vouchers found.",
    limitSaved: "Shared limit saved.",
    quickSearch: "Find a number from 000 to 999",
    enterNumber: "Enter number",
    employeeOnly: "Employees can view their own vouchers.",
    adminOnly: "Admin access",
    language: "Language",
    systemReady: "Workspace ready",
    workspace: "WORKSPACE",
    mainNavigation: "Main navigation",
    adminWorkspace: "Admin workspace",
    employeeWorkspace: "Employee workspace",
    manageLimitsTeam: "Manage limits and your team.",
    refresh: "Refresh",
    dismiss: "Dismiss",
    createDrawPrompt: "Create a draw from the Winning number page to start recording.",
    askAdminPrompt: "Ask your Admin to start a draw.",
    firstTimeSetup: "FIRST-TIME SETUP",
    teamAccess: "TEAM ACCESS",
    bootstrapMissing: "Set BOOTSTRAP_KEY using the setup guide before creating the first Admin.",
    passwordStorageNote: "Passwords are stored as salted hashes.",
    clearerRecord: "A CLEARER WAY TO RECORD",
    keepNumbers: "Keep every number in its place.",
    focusedLedger: "A focused ledger for your team, vouchers, and daily totals.",
    secureWorkspace: "SECURE WORKSPACE",
    roleAdmin: "ADMIN",
    roleEmployee: "EMPLOYEE",
    recordSection: "RECORDS / CURRENT DRAW",
    adminEdit: "ADMIN EDIT",
    records: "records",
    customer: "Customer",
    status: "Status",
    created: "Created",
    drawControl: "DRAW CONTROL",
    noOpenDraw: "NO OPEN DRAW",
    drawOpen: "OPEN",
    review: "Review",
    clear: "Clear",
    activeVoucher: "Active vouchers",
    numbersWithSales: "Numbers with sales",
    limitAppliedNote: "One shared limit applies to every number",
    setLimitNote: "Set the shared limit in Settings.",
    noOverLimitNumbers: "No numbers are over the shared limit.",
    allNumbersShown: "All 1,000 numbers are shown below.",
    remove: "Remove",
    employeePageLead: "Create and manage employee access.",
    employeeList: "Employee list",
    accounts: "accounts",
    passwordMinimum: "Use a password with at least 10 characters.",
    accessTeam: "ACCESS / TEAM",
    adminPreferences: "ADMIN / PREFERENCES",
    salesControls: "Sales controls",
    adminRequired: "Admin access required",
    reportExport: "REPORTS / EXPORT",
    topNumbersByAmount: "Top numbers by amount",
    resultHistory: "Draw history",
    voucherSaved: "Voucher saved.",
    drawUpdated: "Draw updated.",
    limitWatch: "Limit watch",
    drawPlaceholder: "Draw",
    currencyMyanmar: "Myanmar Kyat",
    currencyThai: "Thai Baht",
    currencyUS: "US Dollar",
    connectionError: "Unable to connect to the app.",
    loadRecordsError: "Unable to load records.",
    signInError: "Unable to sign in.",
    saveVoucherError: "Unable to save voucher.",
    voidVoucherError: "Unable to void voucher.",
    updateVoucherError: "Unable to update voucher.",
    reportError: "Unable to load report.",
    saveResultError: "Unable to save result.",
    createDrawError: "Unable to create draw.",
    apiSyncError: "API sync is not configured.",
    loadEmployeesError: "Unable to load employees.",
    createEmployeeError: "Unable to create employee.",
    updateEmployeeError: "Unable to update employee.",
    saveSettingsError: "Unable to save settings.",
  },
  my: {
    appName: "My-Hub",
    pos: "3DPOS",
    dashboard: "အကျဉ်းချုပ်",
    entries: "ထိုးကွက်စာရင်းသွင်းရန်",
    vouchers: "ဘောက်ချာများ",
    reports: "စာရင်းချုပ်",
    results: "ပေါက်ဂဏန်း",
    employees: "ဝန်ထမ်းများ",
    settings: "သတ်မှတ်ချက်များ",
    signOut: "ထွက်ရန်",
    signIn: "ဝင်ရန်",
    username: "အသုံးပြုသူအမည်",
    password: "စကားဝှက်",
    fullName: "အမည်အပြည့်အစုံ",
    customerName: "ထိုးသူအမည်",
    amount: "ငွေပမာဏ",
    totalAmount: "စုစုပေါင်းငွေ",
    maxLimit: "နံပါတ်တိုင်းအတွက် အများဆုံးငွေ",
    save: "သိမ်းရန်",
    cancel: "မလုပ်တော့ပါ",
    copy: "စာရင်းကူးရန်",
    copyOverage: "ကျော်လွန်ပမာဏသာ ကူးယူရန်",
    copyOverageStateFailed: "ယခင်ကူးပြီးသားပမာဏကို မဖတ်နိုင်ပါ။ ထပ်ပို့မိခြင်းမဖြစ်စေရန် ကူးယူခလုတ်ကို ပိတ်ထားသည်။",
    noNewOverageToCopy: "နောက်ဆုံးအောင်မြင်စွာကူးပြီးနောက် အသစ်တိုးလာသော ကျော်ငွေမရှိပါ။",
    copyOverageSuccess: "အသစ်တိုးလာသော ကျော်ငွေကိုသာ ကူးပြီး ဒီ Draw အတွက် မှတ်သားထားသည်။ နောက်တစ်ကြိမ်တွင် ထပ်မပါပါ။",
    copyOverageClipboardFailed: "Clipboard သို့ ကူးယူမရပါ။ မည်သည့်ပမာဏကိုမျှ ပို့ပြီးဟု မှတ်သားမထားပါ။",
    copyOverageTrackingFailed: "ကူးယူပြီးပါပြီ၊ သို့သော် ပို့ပြီးကြောင်း မှတ်တမ်းမသိမ်းနိုင်ပါ။ နောက်တစ်ကြိမ်တွင် ထပ်ပါနိုင်သဖြင့် ပြန်စစ်ပါ။",
    copied: "ကူးပြီးပါပြီ",
    addNumber: "နံပါတ်ထည့်ရန်",
    addLine: "စာကြောင်းထည့်ရန်",
    singleEntry: "တစ်ခုချင်းထည့်ရန်",
    bulkEntry: "အများကြီးထည့်ရန်",
    bulkHint: "တစ်ကြောင်းလျှင်တစ်ခု: 123 5000၊ 259 R 25000 (၆ ကွက်လုံး တူညီ)၊ 259 30000 R 20000 (259 ကို 30000၊ ကျန် ၅ ကွက်ကို 20000)။ နောက်ဂဏန်းသက်သက်သည် စည်းမျဉ်းကို ဆက်ယူသည်။ Tri အတွက် T 25000 ဟုရေးပါ။",
    betNotationHint: "R/r သည် ထူးခြားသောပတ်လည်ဂဏန်းများကို ထိုးသည်။ ငွေနှစ်မျိုးပါလျှင် မူရင်းဂဏန်းကို ပထမငွေ၊ ကျန်ပတ်လည်ဂဏန်းများကို R/r နောက်ကငွေ သတ်မှတ်သည်။ နောက်ဂဏန်းသက်သက်က ယခင်စည်းမျဉ်းကို ဆက်ယူသည်။ T သည် 000၊ 111၊ …၊ 999 ကို သတ်မှတ်ငွေ တစ်ကွက်စီ ထိုးသည်။",
    choosePhoto: "ပုံပြခန်း/ဖိုင်မှ ဓာတ်ပုံရွေးရန်",
    takePhoto: "ကင်မရာဖြင့် ဓာတ်ပုံရိုက်ရန်",
    readPhoto: "Cloudflare AI ဖြင့်ဖတ်ရန်",
    clearPhoto: "ဓာတ်ပုံနှင့် OCR ရလဒ်ရှင်းရန်",
    ocrCloudflareHint: "ဓာတ်ပုံကို Cloudflare Workers AI (Qwen 3.8 Vision) သို့ပို့မည်။ AI က လက်ရေးကို မှားဖတ်နိုင်သေးသဖြင့် မူရင်းဓာတ်ပုံနှင့် ဂဏန်း/ငွေပမာဏတိုင်းကို တိုက်စစ်ပါ။ ပုံနှင့်အဖြေ tokens အလိုက် အသုံးစရိတ်ကွာနိုင်သည်။ နေ့စဉ် 10,000 Neurons အခမဲ့ပါသည်။ Workers Free တွင် ပမာဏကျော်လျှင် request များရပ်မည်။ Workers Paid တွင် ပိုသုံးပါက စရိတ်ရှိနိုင်သည်။",
    ocrReading: "Cloudflare AI ဖတ်နေသည်",
    ocrReady: "AI အကြံပြုချက်များကို bulk entry ထဲထည့်ထားသည်။ မူရင်းဓာတ်ပုံနှင့်တိုက်ပြီး လိုင်းတိုင်းကို ပြန်စစ်/ပြင်ပါ။",
    ocrUnrecognized: "မဖတ်နိုင်သော စာသား — မသိမ်းမီပြန်စစ်ပါ",
    ocrRawText: "AI မူရင်းအဖြေ",
    ocrNoEntries: "AI က ထိုးကွက်စာကြောင်းများကို မသိရှိနိုင်ပါ။ ဓာတ်ပုံကို ပြန်စစ်နိုင်ပါသေးသည်။ စာရွက်ကို အနီးကပ်၊ ကြည်လင်ပြီး အလင်းရောင်ကောင်းစွာ ရိုက်ပါ၊ သို့မဟုတ် ကိုယ်တိုင်ရိုက်ထည့်ပါ။",
    ocrHumanConfirm: "ထည့်သွင်းထားသော ဂဏန်းနှင့် ငွေပမာဏအားလုံးကို ဓာတ်ပုံနှင့် တိုက်စစ်ပြီး မဖတ်နိုင်သောစာသားများကိုလည်း ပြန်စစ်ပြီးပါပြီ။ ပြင်ဆင်ပြီးသောစာရင်းကိုသာ သိမ်းပါမည်။",
    ocrImageOnly: "ဓာတ်ပုံဖိုင်ကို ရွေးပါ။",
    ocrImageTooLarge: "ဓာတ်ပုံဖိုင်သည် 12 MB ထက် မကြီးရပါ။",
    ocrReplacePrompt: "ဓာတ်ပုံဖတ်လျှင် လက်ရှိစာရင်းလိုင်းများကို အစားထိုးပါမည်။ ဆက်လုပ်မလား?",
    ocrFailed: "Cloudflare AI က ဓာတ်ပုံကို မဖတ်နိုင်ပါ။ ပိုရှင်းသောဓာတ်ပုံသုံးပါ၊ သို့မဟုတ် ကိုယ်တိုင်ထည့်ပါ။",
    selectedPhoto: "OCR ပြန်စစ်ရန် ရွေးထားသော မူရင်းဓာတ်ပုံ",
    deletePermanent: "အပြီးဖျက်ရန်",
    deleteVoucherTitle: "ဘောက်ချာကို အပြီးဖျက်မည်",
    deleteVoucherSummary: "ဘောက်ချာနံပါတ်",
    deleteVoucherWarning: "ဤလုပ်ဆောင်ချက်သည် ဘောက်ချာနှင့် ၎င်း၏နံပါတ်/ငွေလိုင်းများကို အပြီးဖျက်ပြီး စုစုပေါင်းနှင့် report များမှ ဖယ်ရှားမည်ဖြစ်သည်။ ပြန်ယူ၍မရပါ။ မှတ်တမ်းကို ထိန်းထားလိုပါက Void ကိုသုံးပါ။",
    deleteVoucherAcknowledge: "အပြီးဖျက်ခြင်းကို ပြန်ပြင်၍မရကြောင်း နားလည်ပါသည်။",
    deleteVoucherConfirm: "အပြီးဖျက်မည်",
    deleteVoucherSuccess: "ဘောက်ချာကို အပြီးဖျက်ပြီးပါပြီ။",
    deleteVoucherError: "ဘောက်ချာကို အပြီးဖျက်၍ မရပါ။",
    number: "နံပါတ်",
    overLimit: "သတ်မှတ်ငွေကျော်နေသည်",
    noLimit: "ကန့်သတ်စစ်ဆေးရန် Settings တွင် shared limit သတ်မှတ်ပါ။",
    totalSales: "စုစုပေါင်းအရောင်း",
    voucherCount: "ဘောက်ချာအရေအတွက်",
    currentDraw: "လက်ရှိအကြိမ်",
    newDraw: "အကြိမ်အသစ်စရန်",
    closeDraw: "လက်ရှိအကြိမ်ပိတ်ပြီး အသစ်စပါမည်။",
    drawName: "အကြိမ်အမည်",
    drawDate: "ရက်စွဲ",
    winningNumber: "ပေါက်ဂဏန်း (000–999)",
    saveResult: "ရလဒ်သိမ်းရန်",
    manualResult: "ကိုယ်တိုင်ရလဒ်ထည့်ရန်",
    syncApi: "API မှရယူရန်",
    apiPending: "နောက်ဆုံး GLO 3D ရလဒ်ကို ရယူရန် Cloudflare တွင် SETLIVE_API_KEY သတ်မှတ်ပါ။ ရက်စွဲနှင့် ဂဏန်းကို တရားဝင်ရင်းမြစ်နှင့် ပြန်စစ်ပါ။",
    search: "အမည် သို့မဟုတ် ဘောက်ချာနံပါတ်ရှာရန်",
    from: "မှ",
    to: "အထိ",
    downloadCsv: "CSV ဒေါင်းလုဒ်",
    employee: "ဝန်ထမ်း",
    createEmployee: "ဝန်ထမ်းအကောင့်ဖန်တီးရန်",
    active: "အသုံးပြုနေသည်",
    inactive: "ပိတ်ထားသည်",
    deactivate: "ပိတ်ရန်",
    activate: "ပြန်ဖွင့်ရန်",
    print: "ဘောက်ချာထုတ်ရန်",
    void: "ဘောက်ချာပယ်ဖျက်ရန်",
    edit: "ပြင်ရန်",
    reason: "အကြောင်းပြချက်",
    overrideReason: "Admin ခွင့်ပြုချက်အကြောင်းပြချက်",
    loginIntro: "ထီစာရင်းသို့ ဝင်ပါ။",
    setupIntro: "ပထမဆုံး Admin အကောင့်ကို ဖန်တီးပြီး စနစ်ကို ကာကွယ်ပါ။",
    bootstrapKey: "စတင်သတ်မှတ်ရန် key",
    setupAdmin: "Admin ဖန်တီးရန်",
    noEntries: "စာရင်းမရှိသေးပါ။",
    noVouchers: "ဘောက်ချာမတွေ့ပါ။",
    limitSaved: "Shared limit သိမ်းပြီးပါပြီ။",
    quickSearch: "000 မှ 999 အထိ နံပါတ်ရှာရန်",
    enterNumber: "နံပါတ်ထည့်ရန်",
    employeeOnly: "ဝန်ထမ်းသည် ကိုယ်တိုင်ဖန်တီးထားသော ဘောက်ချာများကို ကြည့်နိုင်သည်။",
    adminOnly: "Admin ခွင့်ပြုချက်",
    language: "ဘာသာစကား",
    systemReady: "အသုံးပြုရန် အသင့်ဖြစ်ပါပြီ",
    workspace: "လုပ်ငန်းခွင်",
    mainNavigation: "အဓိကမီနူး",
    adminWorkspace: "Admin လုပ်ငန်းခွင်",
    employeeWorkspace: "ဝန်ထမ်းလုပ်ငန်းခွင်",
    manageLimitsTeam: "ငွေကန့်သတ်ချက်နှင့် ဝန်ထမ်းများကို စီမံပါ။",
    refresh: "ပြန်လည်စစ်ဆေးရန်",
    dismiss: "ပိတ်ရန်",
    createDrawPrompt: "မှတ်တမ်းတင်ရန် Winning number စာမျက်နှာမှ အကြိမ်အသစ်စပါ။",
    askAdminPrompt: "အကြိမ်အသစ်စရန် Admin ထံ ဆက်သွယ်ပါ။",
    firstTimeSetup: "ပထမဆုံး စတင်သတ်မှတ်ခြင်း",
    teamAccess: "အဖွဲ့ဝင်ဝင်ရောက်မှု",
    bootstrapMissing: "ပထမဆုံး Admin မဖန်တီးမီ setup guide အတိုင်း BOOTSTRAP_KEY သတ်မှတ်ပါ။",
    passwordStorageNote: "Password များကို salted hash အဖြစ် သိမ်းထားသည်။",
    clearerRecord: "စာရင်းသွင်းမှုကို ပိုမိုရှင်းလင်းစေသည်",
    keepNumbers: "နံပါတ်တိုင်းကို စနစ်တကျ မှတ်တမ်းတင်ပါ။",
    focusedLedger: "အဖွဲ့၊ ဘောက်ချာနှင့် နေ့စဉ်စုစုပေါင်းများအတွက် ရှင်းလင်းသောစာရင်း။",
    secureWorkspace: "လုံခြုံသော လုပ်ငန်းခွင်",
    roleAdmin: "အုပ်ချုပ်သူ",
    roleEmployee: "ဝန်ထမ်း",
    recordSection: "မှတ်တမ်း / လက်ရှိအကြိမ်",
    adminEdit: "Admin ပြင်ဆင်ရန်",
    records: "မှတ်တမ်းများ",
    customer: "ထိုးသူ",
    status: "အခြေအနေ",
    created: "ဖန်တီးသည့်နေ့",
    drawControl: "အကြိမ်စီမံခန့်ခွဲမှု",
    noOpenDraw: "ဖွင့်ထားသောအကြိမ်မရှိပါ",
    drawOpen: "ဖွင့်ထားသည်",
    review: "စစ်ဆေးရန်",
    clear: "ကျော်လွန်မှုမရှိပါ",
    activeVoucher: "အသုံးပြုနေသော ဘောက်ချာများ",
    numbersWithSales: "ထိုးငွေရှိသော နံပါတ်များ",
    limitAppliedNote: "နံပါတ်အားလုံးတွင် shared limit တူညီစွာ အသုံးပြုသည်",
    setLimitNote: "Admin က Settings တွင် shared limit သတ်မှတ်ပါ။",
    noOverLimitNumbers: "လက်ရှိတွင် shared limit ကျော်သော နံပါတ်မရှိပါ။",
    allNumbersShown: "နံပါတ် ၁,၀၀၀ လုံးကို အောက်တွင် ပြထားသည်။",
    remove: "ဖယ်ရှားရန်",
    employeePageLead: "ဝန်ထမ်းအကောင့်များကို ဖန်တီးစီမံပါ။",
    employeeList: "ဝန်ထမ်းစာရင်း",
    accounts: "အကောင့်များ",
    passwordMinimum: "အနည်းဆုံး စာလုံး ၁၀ လုံးပါသော password သုံးပါ။",
    accessTeam: "ဝင်ရောက်ခွင့် / ဝန်ထမ်းအဖွဲ့",
    adminPreferences: "Admin / သတ်မှတ်ချက်များ",
    salesControls: "အရောင်းထိန်းချုပ်မှုများ",
    adminRequired: "Admin ခွင့်ပြုချက် လိုအပ်သည်",
    reportExport: "အစီရင်ခံစာ / ဒေါင်းလုဒ်",
    topNumbersByAmount: "ငွေပမာဏအများဆုံး နံပါတ်များ",
    resultHistory: "အကြိမ်မှတ်တမ်း",
    voucherSaved: "ဘောက်ချာသိမ်းပြီးပါပြီ။",
    drawUpdated: "အကြိမ်အချက်အလက် ပြင်ဆင်ပြီးပါပြီ။",
    limitWatch: "ကန့်သတ်ငွေ သတိပေးချက်",
    drawPlaceholder: "အကြိမ်",
    currencyMyanmar: "မြန်မာကျပ်",
    currencyThai: "ထိုင်းဘတ်",
    currencyUS: "အမေရိကန်ဒေါ်လာ",
    connectionError: "App သို့ ချိတ်ဆက်၍ မရပါ။",
    loadRecordsError: "စာရင်းများကို ဖွင့်၍ မရပါ။",
    signInError: "ဝင်ရောက်၍ မရပါ။",
    saveVoucherError: "ဘောက်ချာသိမ်း၍ မရပါ။",
    voidVoucherError: "ဘောက်ချာပယ်ဖျက်၍ မရပါ။",
    updateVoucherError: "ဘောက်ချာပြင်ဆင်၍ မရပါ။",
    reportError: "အစီရင်ခံစာကို ဖွင့်၍ မရပါ။",
    saveResultError: "ရလဒ်သိမ်း၍ မရပါ။",
    createDrawError: "အကြိမ်အသစ် ဖန်တီး၍ မရပါ။",
    apiSyncError: "API ချိတ်ဆက်မှု မသတ်မှတ်ရသေးပါ။",
    loadEmployeesError: "ဝန်ထမ်းစာရင်းကို ဖွင့်၍ မရပါ။",
    createEmployeeError: "ဝန်ထမ်းအကောင့် ဖန်တီး၍ မရပါ။",
    updateEmployeeError: "ဝန်ထမ်းအချက်အလက် ပြင်ဆင်၍ မရပါ။",
    saveSettingsError: "သတ်မှတ်ချက်များကို သိမ်း၍ မရပါ။",
  },
} as const;

export type MessageKey = keyof typeof messages.en;
export function translate(language: Language, key: MessageKey): string {
  return messages[language][key] ?? messages.en[key];
}
